import { Component, Input, OnInit, HostListener } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { EdpContractListComponent } from "@edp-components/edp-contract-list/edp-contract-list.component";
import { EdpModalService } from "@edp-components/edp-modal";
import { ContractService } from "@edp-services/contract.service";
import { environment } from "@edp-environments/environment";
import { Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { Menu } from "@edp-models/menu.model";
import { getMainMenu } from "@edp-store/selectors/layout.selectors";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from "@angular/router";

@Component({
    selector: "edp-contract-consumption-local",
    templateUrl: "./edp-contract-consumption-local.component.html",
    styleUrls: ["./edp-contract-consumption-local.component.scss"],
})
export class EdpContractConsumptionLocalComponent implements OnInit {
    public contract: Contract;
    public isApp: boolean;
    public scroll: boolean;
    public showContractName: boolean;
    public menuTitle: string;

    @HostListener("window:scroll", [])
    onScroll(): void {
        if (window.scrollY === 0) {
            this.scroll = false;
        } else {
            this.scroll = true;
        }
    }

    constructor(
        private edpModalService: EdpModalService,
        private contractService: ContractService,
        private store: Store<IAppState>,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit() {
        this.isApp = environment.isApp;
        this.store.select(getMainMenu).subscribe((menu: Menu[]) => {
            menu.forEach(menuItem => {
                if (menuItem.isActive) {
                    const customTitle = this.getPageTitle(this.activatedRoute);
                    this.menuTitle = !customTitle ? menuItem.name : customTitle;
                    this.showContractName = ["MENU.ENERGY-E", "MENU.ENERGY-SOLAR"].includes(menuItem.name);
                }
            });
        });

        this.store.select(getContract).subscribe((contract: Contract) => {
            if (!!contract) {
                this.contract = contract;
            }
        });
    }

    public showContractList(canClose: boolean) {
        this.router.navigate([`/locais-consumo/${this.contract.ContractId}/inicio`]);
    }

    public getPageTitle(route: ActivatedRoute): any {
        if (route.firstChild) {
            return this.getPageTitle(route.firstChild);
        } else {
            return route.snapshot.data.pageTitle;
        }
    }
}
